module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAASpJREFUSInFlTFSg0AUhr9HOICN6W0tvEKITo5AZ85COAtacYRMIlxBZ9Jq61h4A54FIewKayDA+Fc7y5v/32/eYxcmlnQpStJtUBbPIkXzcrfI1uEqGxTwnO4zRRd/1SjE6/Bh0ysgSbeB4L2cO12XIK9pvtv0NQcQiJJ01wiwCEpzor7mppRiafbGIhhqXnrY9KeANrxL9ZTuTyF+nWyf/u72hvn11Vmzt8MHn1/fv3Y1qFYe1HM+pirPI4HXCHg9vI8S1BjTMSSICrMIjgSCLECtoiE9UFQUcpiIwJTv+jC8B0UGExJUf7OTwNWD9rm3pRBX60kIzFt19B6Yp4eRCdreBCdBf3P7mr44QBBV1HhHJHsM75euer9M11y6vf8ooBQx1KP4r/oB88VtlREmXyMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/2.png
// module id = 0gOP
// module chunks = 171